import { render, staticRenderFns } from "./Lgx368820687520923648.vue?vue&type=template&id=02c4de06&scoped=true&"
import script from "./Lgx368820687520923648.vue?vue&type=script&lang=js&"
export * from "./Lgx368820687520923648.vue?vue&type=script&lang=js&"
import style0 from "./Lgx368820687520923648.vue?vue&type=style&index=0&id=02c4de06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4de06",
  null
  
)

export default component.exports